<template>
	<div id="noticeBox" class="statv_wrapper">
		<h3 class="disabled"> NOTICE </h3>
    <div class="board_link">
      <p @click="linkDetail">전체 보기</p>
    </div>
		<div class="notice_container">
        <div class="notice_box" v-for="(notice, idx) in notices.slice(0 ,3)" :key="`notice_${idx}`">
					<div class="notice_item" @click.prevent="linkDetail(notice.id)">
						<div class="cell"> {{setType(notice.board_type)}} </div>
						<div class="cell"> {{notice.title}} </div>
					</div>
				</div>
		</div>
	</div>
</template>
<script>
import * as Store from '@/store/modules/board'
import "slick-carousel/slick/slick.css";

export default {
	components : {
	},
	data() {
		return {
		}
	},
	computed: {
		...Store.mapState([ 'notices' ]),
	},
	async created() {
		await this.getBoards({
      'page': 1,
      'keyword': '',
      'limit': 3
    })
	},
	updated() {
		this.$nextTick(function() {
		if(this.$refs.noticeSlick) {
			this.$refs.noticeSlick.create(this.slickOptions);
		}
		})
	},
	beforeUpdate() {
		if (this.$refs.noticeSlick) {
			this.$refs.noticeSlick.destroy();
		}
	},
	beforeDestroy() {
		if (this.$refs.noticeSlick) {
			this.$refs.noticeSlick.destroy();
		}
	},
	methods: {
		...Store.mapActions([ 'getBoards' ]),
		setType(type) {
			let result = '';
			switch(type) {
				case 1 :  result = '공지'
						break
				case 2 :  result = '이벤트'
						break
				default:  break
			}
			return result
		},
		linkDetail(id) {
      if (id) {
        const parsedId = encodeURIComponent(id.toString());
        this.$router.push(`/notice/?id=${parsedId}`);
      } else {
        this.$router.push("/notice");
      }
    }
	}
}
</script>
<style lang="less">
#noticeBox {
	height: auto;
  .board_link {
    padding: 23px 0 7px 0;
    background-color: #f8f8f8;
    text-align: right;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-size: 18px;
    font-weight: 400;
    color: #ff6400;
    cursor: pointer;
    &::after {
      content: ">";
      color: #ff6400;
    }
  }
	.notice_container {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
		width: 100%;
    height: 129px;
    .notice_box {
      width: 100%;
      height: 36px;
      background-color: #fff;
      color: #ff6400;
      font-size: 18px;
      font-weight: 400;
      transform: skew(-0.05deg);
      .notice_item {
					display: flex !important;
					flex-flow: row wrap;
					align-items: center;
					// width: 100%;
					height: 36px;
					cursor: pointer;
					.cell {
						min-width: 83px;
						&:first-child {
							position: relative;
							margin-right: 20px;
							text-align: center;
              font-weight: bold;
							&::after {
								content: "";
								display: block;
								position: absolute;
								width: 2px;
								height: 22px;
								background-color:#ff6400;
								right: 0;
								bottom: 0;
							}
						}
						&:last-child {
							width: 800px;
							display: inline-block;
							white-space: nowrap;
							word-break: break-all;
							text-overflow:ellipsis;
							overflow: hidden;
						}
					}
				}

    }
	}
}

.m #noticeBox {
	height: auto;
  .board_link {
    width: 100%;
    font-size: 22px;
    padding-top: 10px;
  }
	.notice_container {
		display: flex;
		height: auto;
    .notice_box {
      height: 60px;
      font-size: 22px;
      margin-bottom: 7px;
      .notice_item {
        height: 100%;
        .cell {
          &:last-child {
            width: 450px;
          }
        }
      }
    }
	}
}
</style>